module.exports = "/components/components/foldableSearch-81ebd2.html";